import { Visibility, VisibilityOff } from '@mui/icons-material'
import { FormControl, FormHelperText, IconButton, InputAdornment, InputLabel, OutlinedInput, OutlinedInputProps } from '@mui/material'
import React from 'react'
import { getLabelForFieldName } from '../../utils'
import { AdornmentTypography } from './text-input.styles'

export type TextInputProps = OutlinedInputProps & {
	label?: string,
	hideMaskedFields?: boolean,
	isMasked?: boolean,
	description?: string,
	errorText?: string,
}

export const TextInput = ( { hideMaskedFields, isMasked, description, errorText, ...props }: TextInputProps ) => {
	const [ showMaskedField, setShowMaskedField ] = React.useState( false )

	const label = props.name ? getLabelForFieldName( props.name, props.label ) : props.label

	const handleClickShowMaskedField = () => setShowMaskedField( ( show ) => !show )

	if ( isMasked ) {
		// If the field is masked, use the InputAdornment to show a masked input
		const shouldShowAdornment = !hideMaskedFields
		return (
			<FormControl variant="outlined">
				<InputLabel htmlFor={label}>{label}</InputLabel>
				<OutlinedInput
					{...props}
					type={ showMaskedField ? 'text' : 'password' }
					aria-label={label}
					spellCheck={false}
					endAdornment={ shouldShowAdornment &&
						<InputAdornment position="end">
							<AdornmentTypography variant="body2" color="textSecondary">
								{showMaskedField ? 'Hide' : 'Show'} {label}
							</AdornmentTypography>
							<IconButton
								aria-label={
									showMaskedField ? 'hide the password' : 'display the password'
								}
								onClick={handleClickShowMaskedField}
								edge="end"
							>
								{showMaskedField ? <VisibilityOff /> : <Visibility />}
							</IconButton>
						</InputAdornment>
					}
				/>
				{description && <FormHelperText>{description}</FormHelperText>}
				{errorText && <FormHelperText error>{errorText}</FormHelperText>}
			</FormControl>

		)
	}

	return (
		<FormControl variant="outlined">
			<InputLabel htmlFor={label}>{label}</InputLabel>
			<OutlinedInput
				aria-label={label}
				spellCheck={false}
				name={props.name}
				{...props}
			/>
			{description && <FormHelperText>{description}</FormHelperText>}
			{errorText && <FormHelperText error>{errorText}</FormHelperText>}
		</FormControl>
	)
}
